import React from "react";

export default function FullPageLoader({ label = "Loading..." }) {
  return (
    <div className="app-fullpage-loader" role="status" aria-live="polite">
      <div className="app-fullpage-loader-spinner" aria-hidden="true" />
      <p className="app-fullpage-loader-text">{label}</p>
    </div>
  );
}

